/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useId } from 'react';
import {
  CustomRadio,
  Input,
  RadioLabel,
  RadioInfoWrapper,
  RadioTextWrapper,
  RadioDescription,
  RadioText,
} from './radio.styles';

interface Props {
  title?: JSX.Element | string;
  description?: JSX.Element | string;
  checked: boolean;
  name?: string;
  value?: string | number;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLLabelElement>) => void;
}

const Radio = ({
  checked,
  name,
  value,
  title,
  description,
  disabled,
  onChange,
  onClick,
}: Props) => {
  const id = useId();

  const titleIsString = typeof title === 'string';
  const descriptionIsString = typeof description === 'string';

  return (
    <RadioLabel
      htmlFor={id}
      $disabled={disabled}
      onClick={onClick}>
      <Input
        id={id}
        name={name}
        value={value}
        type='radio'
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          onChange?.(e);
        }}
      />
      <CustomRadio
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
      <RadioInfoWrapper>
        <RadioTextWrapper>
          {titleIsString ? <RadioText>{title}</RadioText> : title}
        </RadioTextWrapper>
        {description &&
          (descriptionIsString ? (
            <RadioDescription>{description}</RadioDescription>
          ) : (
            description
          ))}
      </RadioInfoWrapper>
    </RadioLabel>
  );
};

export default Radio;
